// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../node_modules/ui-connect/styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-nav-item .header-nav-menu .js-new-requests-link > .new-items-alert {
    position: absolute;
    right: 9px;
    top: 14px;
    z-index: 1;
    padding: 0;
    min-width: 8px;
    width: 8px;
    height: 8px;
}

.header-nav-item.notifications .request-item .notification-body {
    padding-left: 26px;
}

.header-nav-item.notifications .request-item.unread {
    background-color: inherit;
}

.header-nav-item.notifications .request-item.unread:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_1"]};
}

.header-nav-item.notifications .request-item.unread::after {
    content: '';
    width: 8px;
    height: 8px;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_primary"]};
    border-radius: 50%;
    display: block;
    position: absolute;
    left: 8px;
    top: 42px;
    transform: translate(0, -50%);
}
.header-nav-item.notifications .request-item.inbox-link.unread::after {
    top: 37px;
}

.header-nav-item.notifications .request-item.inbox-link {
    text-decoration: none;
    align-items: center;
    padding-left: 26px;
}
.header-nav-item.notifications .request-item.inbox-link:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_1"]};
}
.header-nav-item.notifications .request-item.inbox-link :nth-child(2) {
    flex-grow: 1;
}
.header-nav-item.notifications .request-item.inbox-link .inbox-link-request-images {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 10px;
}
.header-nav-item.notifications .request-item.inbox-link .inbox-link-request-images > img {
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
}
.header-nav-item.notifications .request-item.inbox-link .inbox-link-request-images > img:first-child {
    position: absolute;
    left: 0;
    top: 0;
}
.header-nav-item.notifications .request-item.inbox-link .inbox-link-request-images > img:last-child {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
}

.header-nav-item.notifications .notification-item .notification-body {
    padding-left: 26px;
}

.header-nav-item.notifications .notification-item.unread {
    background-color: inherit;
}

.header-nav-item.notifications .notification-item.unread::after {
    content: '';
    width: 8px;
    height: 8px;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_primary"]};
    border-radius: 50%;
    display: block;
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translate(0, -50%);
}

.header-nav-item.notifications .notification-item:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_1"]};
}
.header-nav-item.notifications .notification-item.unread:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_1"]};
}

.header-nav-item.notifications .request-item .inbox-response {
    font-size: 12px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textMedium"]};
}

.header-nav-item.notifications .request-image {
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/styles/notificationsPopupMenu.module.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,UAAU;IACV,cAAc;IACd,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8DAAmC;AACvC;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,8DAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,6BAA6B;AACjC;AACA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,8DAAmC;AACvC;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,8DAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,8DAAmC;AACvC;AACA;IACI,8DAAmC;AACvC;;AAEA;IACI,eAAe;IACf,mDAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["@value (blue_primary, lightui_surface_1, textMedium) from 'ui-connect/styles/colors.module.css';\n\n:global .header-nav-item .header-nav-menu .js-new-requests-link > .new-items-alert {\n    position: absolute;\n    right: 9px;\n    top: 14px;\n    z-index: 1;\n    padding: 0;\n    min-width: 8px;\n    width: 8px;\n    height: 8px;\n}\n\n:global .header-nav-item.notifications .request-item .notification-body {\n    padding-left: 26px;\n}\n\n:global .header-nav-item.notifications .request-item.unread {\n    background-color: inherit;\n}\n\n:global .header-nav-item.notifications .request-item.unread:hover {\n    background-color: lightui_surface_1;\n}\n\n:global .header-nav-item.notifications .request-item.unread::after {\n    content: '';\n    width: 8px;\n    height: 8px;\n    background-color: blue_primary;\n    border-radius: 50%;\n    display: block;\n    position: absolute;\n    left: 8px;\n    top: 42px;\n    transform: translate(0, -50%);\n}\n:global .header-nav-item.notifications .request-item.inbox-link.unread::after {\n    top: 37px;\n}\n\n:global .header-nav-item.notifications .request-item.inbox-link {\n    text-decoration: none;\n    align-items: center;\n    padding-left: 26px;\n}\n:global .header-nav-item.notifications .request-item.inbox-link:hover {\n    background-color: lightui_surface_1;\n}\n:global .header-nav-item.notifications .request-item.inbox-link :nth-child(2) {\n    flex-grow: 1;\n}\n:global .header-nav-item.notifications .request-item.inbox-link .inbox-link-request-images {\n    position: relative;\n    width: 40px;\n    height: 40px;\n    margin-right: 10px;\n}\n:global .header-nav-item.notifications .request-item.inbox-link .inbox-link-request-images > img {\n    position: absolute;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n}\n:global .header-nav-item.notifications .request-item.inbox-link .inbox-link-request-images > img:first-child {\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n:global .header-nav-item.notifications .request-item.inbox-link .inbox-link-request-images > img:last-child {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n}\n\n:global .header-nav-item.notifications .notification-item .notification-body {\n    padding-left: 26px;\n}\n\n:global .header-nav-item.notifications .notification-item.unread {\n    background-color: inherit;\n}\n\n:global .header-nav-item.notifications .notification-item.unread::after {\n    content: '';\n    width: 8px;\n    height: 8px;\n    background-color: blue_primary;\n    border-radius: 50%;\n    display: block;\n    position: absolute;\n    left: 8px;\n    top: 50%;\n    transform: translate(0, -50%);\n}\n\n:global .header-nav-item.notifications .notification-item:hover {\n    background-color: lightui_surface_1;\n}\n:global .header-nav-item.notifications .notification-item.unread:hover {\n    background-color: lightui_surface_1;\n}\n\n:global .header-nav-item.notifications .request-item .inbox-response {\n    font-size: 12px;\n    color: textMedium;\n}\n\n:global .header-nav-item.notifications .request-image {\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue_primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_primary"]}`,
	"lightui_surface_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_1"]}`,
	"textMedium": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textMedium"]}`,
	"header-nav-item": `header-nav-item`,
	"header-nav-menu": `header-nav-menu`,
	"js-new-requests-link": `js-new-requests-link`,
	"new-items-alert": `new-items-alert`,
	"notifications": `notifications`,
	"request-item": `request-item`,
	"notification-body": `notification-body`,
	"unread": `unread`,
	"inbox-link": `inbox-link`,
	"inbox-link-request-images": `inbox-link-request-images`,
	"notification-item": `notification-item`,
	"inbox-response": `inbox-response`,
	"request-image": `request-image`
};
export default ___CSS_LOADER_EXPORT___;
